import { Dialog, DialogContent, DialogOverlay } from "@/components/ui/dialog";
import OnboardingWizard from "./onboarding-form";
import { OnboardingProvider, useOnboarding } from "./onboarding-provider";
import { usePopupStore } from "@/stores/popup.store";
import { useTourProgress } from "@/hooks/use-organisation";

const OnboardingWizardDialog = () => {
  return (
    <OnboardingProvider>
      <OnboardingWizardContent />
    </OnboardingProvider>
  );
};

const OnboardingWizardContent = () => {
  const { open, setOpen, currentStep, handleOnFinish } = useOnboarding();

  // show close button if current step is greater than 4
  const showCloseButton = currentStep > 4;

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      handleOnFinish("close");
    }
    setOpen(open);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogOverlay className="backdrop-blur-sm bg-black/10" />
      <DialogContent
        className="max-w-4xl p-0 max-h-[85vh] overflow-y-auto mx-auto my-4"
        showCloseButton={showCloseButton}
        onInteractOutside={(e) => {
          if (!showCloseButton) {
            e.preventDefault();
          }
        }}
        onEscapeKeyDown={(e) => {
          if (!showCloseButton) {
            e.preventDefault();
          }
        }}
      >
        <OnboardingWizard />
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingWizardDialog;
